import React, { useState , useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { onLogoutSessions, onUserProfileLoad } from "../../../store/Settings/actions";
import { BrowserSessionModal } from "./BrowserSessionModal";

export const BrowserSessions = () => {
    const [openModal, setOpenModal] = useState(false);
    const [browserSessions, setBrowserSessions] = useState([]); 
    const [confirmPassword, setConfirmPassword] = useState("");
    const dispatch = useDispatch();
    const { t } = useTranslation();   

    const {redirect, browser_sessions_list} = useSelector(({settings}) => ({
        redirect: settings.redirect,
        browser_sessions_list: settings.user_profile.browser_sessions_list,
    }));

    useEffect(()=>{setBrowserSessions(browser_sessions_list)},[browser_sessions_list])
    useEffect(()=>{redirect && dispatch(onUserProfileLoad())},[redirect])

    const onOpenModal = () => {setOpenModal((prev) => !prev)};
    const onCloseModal = () => {setOpenModal((prev) => !prev)};
    const handleConfirmPassword = (e) => {setConfirmPassword(e.target.value)};

    const onSaveHandle = (e) => {
        e.preventDefault()
        dispatch(onLogoutSessions(confirmPassword));
        onCloseModal();
        setConfirmPassword("");
    };

    return (
        <div className="rounded-lg shadow-md bg-white pt-5 pr-12 pb-4 pl-5">
            <p className="font-bold text-base">{t("Browser Sessions")}</p>

            <p className="col-span-3 sm:col-span-3 py-3.5 text-xs text-gray-600">
                {t("Manage and log out from your active sessions on other browsers and devices")}
            </p>

            <p className="col-span-3 sm:col-span-3 py-3.5 text-xs text-gray-600 mb-3">
                {t(
                    "If necessary, log out of all your other browser sessions across all your devices. Some of your recent sessions are listed below. If you feel your account has been compromised, you should also update your password."
                )}
            </p>

            <div className="pt-2 text-right">
                {browserSessions.map(({agent, ip_address, is_current_device, last_active},index)=>(
                    <div className="flex items-center mb-6" key={index}>
                        <div className="mr-3">
                            {agent.is_desktop
                            ? <img src="/desktop.svg" width={30} height={30} alt="desktop" />
                            : <img src="/mobile.svg" width={30} height={30} alt="desktop" />}
                        </div>
                        <div className="leading-3">
                            <div className="text-sm text-left text-gray-600">
                                {agent.platform} - {agent.browser}
                            </div>
                            <div>
                                <span className="text-xs text-gray-500 mr-1">
                                    {ip_address}
                                </span>
                                <span className="text-xs text-green-500 mr-1">
                                    {is_current_device && "This device"}
                                </span>
                                <span className="text-xs text-gray-500">
                                    {last_active && `Last active ${last_active}`}
                                </span>
                            </div>
                        </div>  
                    </div>
                ))}
                <button
                    type="button"
                    onClick={onOpenModal}
                    className="inline-flex justify-center mt-3 py-2 px-6 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                >
                    {t("Log out from browser sessions")}
                </button>

                <BrowserSessionModal
                    visible={openModal}
                    onClose={onCloseModal}
                    onSave={onSaveHandle}
                    confirmPassword={confirmPassword}
                    handleConfirmPassword={handleConfirmPassword}
                />
            </div>
        </div> 
    );
};
